import { useEffect } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";

// Full-screen photo viewer with a big close button (works inside the iPhone home-screen app)
export const PhotoLightbox = ({ src, onClose }) => {
  useEffect(() => {
    if (!src) return;
    const esc = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", esc);
    document.body.style.overflow = "hidden";
    return () => { window.removeEventListener("keydown", esc); document.body.style.overflow = ""; };
  }, [src, onClose]);
  if (!src) return null;
  return createPortal(
    <div className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center p-3" onClick={onClose} data-testid="photo-lightbox">
      <img src={src} alt="Foto" className="max-w-full max-h-full object-contain" onClick={(e) => e.stopPropagation()} data-testid="photo-lightbox-img" />
      <button onClick={onClose} className="absolute right-3 top-[max(0.75rem,env(safe-area-inset-top))] w-12 h-12 rounded-full bg-white text-black flex items-center justify-center shadow-xl" aria-label="Chiudi foto" data-testid="photo-lightbox-close">
        <X className="w-6 h-6" />
      </button>
    </div>,
    document.body,
  );
};
